import React, {Suspense} from 'react';
import ContainerLayout from 'components/containerLayout/ContainerLayout'

const Home = React.lazy(() => import("./pages/Home"));
const Project = React.lazy(() => import("./pages/Project"));
const Assessor = React.lazy(() => import("./pages/Assessor"));
const Video = React.lazy(() => import("./pages/Video"));
const Winner = React.lazy(() => import("./pages/Winner"));
const ContestLive = React.lazy(() => import("./pages/ContestLive"));
const Award = React.lazy(() => import("./pages/Award"));
const Organization = React.lazy(() => import("./pages/Organization"));
const Speech = React.lazy(() => import("./pages/Speech"));
const Session = React.lazy(() => import("./pages/Session"));

import {Route, Redirect, Switch, withRouter} from 'react-router-dom';

const Interview = React.lazy(() => import("./pages/Interview"));
const SpeechDetail = React.lazy(() => import("./pages/SpeechDetail"));
const Work = React.lazy(() => import("./pages/Work"));
const Division = React.lazy(() => import("./pages/Division"));
const DivisionDetail = React.lazy(() => import("./pages/DivisionDetail"));

function ScrollToTop(props) {
    return props.children
}

withRouter(ScrollToTop);

function Main(props) {
    return (
        <div>
            <ContainerLayout {...props}>
                <ScrollToTop {...props}>
                    <Suspense fallback={<div>
                    </div>}>
                        <Switch>
                            <Route path="/home" render={props => <Home {...props}/>}/>
                            <Route path="/project" render={props => <Project{...props}/>}/>
                            <Route path="/assessor" render={props => <Assessor{...props}/>}/>
                            <Route path="/video" render={props => <Video{...props}/>}/>
                            <Route path="/winner" render={props => <Winner {...props}/>}/>
                            <Route exact path="/live" render={props => <ContestLive {...props}/>}/>
                            <Route exact path="/live/award" render={props => <Award {...props} />}/>
                            <Route exact path="/live/organization" render={props => < Organization {...props}/>}/>
                            <Route exact path="/speech" render={props => <Speech {...props}/>}/>
                            <Route exact path="/speech/detail/:id" render={props => <SpeechDetail {...props}/>}/>
                            <Route path="/session/:id" render={props => <Session {...props}/>}/>
                            <Route path="/interview" render={props => <Interview {...props}/>}/>
                            <Route path="/work" render={props => <Work {...props}/>}/>
                            <Route exact path="/division" render={props => <Division {...props}/>}/>
                            <Route exact path="/division/:id" render={props => <DivisionDetail {...props}/>}/>
                            <Redirect from={"/"} to="/home"/>
                        </Switch>
                    </Suspense>
                </ScrollToTop>
            </ContainerLayout>
        </div>
    );
}

export default Main;
